import type { ReactNode } from "react";
import { Navigate } from "react-router-dom";
import { CircularProgress, Box, Typography } from "@mui/material";
import { useSession, type Role } from "./AuthProvider";
import { OnboardingPage } from "../pages/OnboardingPage";

/** Route guard: unauthenticated → login; wrong role → clear message, no data. */
export function RequireRole({ roles, children }: { roles: Role[]; children: ReactNode }) {
  const { user, role, orgId, loading } = useSession();

  if (loading) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" minHeight="60vh">
        <CircularProgress />
      </Box>
    );
  }
  if (!user) return <Navigate to="/login" replace />;

  // A signed-in user with no organization yet is a hall owner mid-onboarding.
  if (role === "customer" && !orgId) {
    return <OnboardingPage />;
  }

  if (!roles.includes(role) && role !== "admin") {
    return (
      <Box p={6} textAlign="center">
        <Typography variant="h6">دسترسی ندارید</Typography>
        <Typography color="text.secondary">
          این بخش برای نقش «{roles.join("، ")}» است. برای دسترسی با مالک تالار تماس بگیرید.
        </Typography>
      </Box>
    );
  }
  return <>{children}</>;
}
